import { ERROR, LOADING, LOADED } from 'data/actions/project';

const INITIAL_STATE = {
    content: {
        title: 'Liberte Cup',
        slug: 'liberte-cup',
        category: {
            fields: {
                title: 'Commercial'
            }
        },
        previewImage: {
            fields: {
                title: 'liberte cup-05',
                file: {
                    url:
                        '//images.contentful.com/kui374n3zzkx/37FCBUimzSQUCGkiwkigWg/94760ba1e944544cb27e6f193a144725/liberte_cup-05.png'
                }
            }
        },
        stills: [
            {
                fields: {
                    title: 'liberte cup-01',
                    file: {
                        url:
                            '//images.contentful.com/kui374n3zzkx/3wd58TugKsW4waUcuUYigI/8f820a85372b20799764272149a45ad1/liberte_cup-01.png'
                    }
                }
            },
            {
                fields: {
                    title: 'liberte cup-02',
                    file: {
                        url:
                            '//images.contentful.com/kui374n3zzkx/1ZMHr2XYzO4AWcWEAcEyIg/93495cf339c7d0de28e1821bf382fa96/liberte_cup-02.png'
                    }
                }
            },
            {
                fields: {
                    title: 'liberte cup-03',
                    file: {
                        url:
                            '//images.contentful.com/kui374n3zzkx/5tKkl9JXIki40CyY8kQW2a/c2b38ddacf7ea2dfc16d0fd05d54f94c/liberte_cup-03.png'
                    }
                }
            },
            {
                fields: {
                    title: 'liberte cup-04',
                    file: {
                        url:
                            '//images.contentful.com/kui374n3zzkx/2LSnHxfQwgEGI6Sk06M2UG/a520080e465a9733e535a1e90aa808e6/liberte_cup-04.png'
                    }
                }
            },
            {
                fields: {
                    title: 'liberte cup-05',
                    file: {
                        url:
                            '//images.contentful.com/kui374n3zzkx/37FCBUimzSQUCGkiwkigWg/94760ba1e944544cb27e6f193a144725/liberte_cup-05.png'
                    }
                }
            },
            {
                fields: {
                    title: 'liberte cup-06',
                    file: {
                        url:
                            '//images.contentful.com/kui374n3zzkx/1mpYqsa9qw0Sg2eyWCQ0Ck/755ea945291a06067df1b86be2ab5359/liberte_cup-06.png'
                    }
                }
            },
            {
                fields: {
                    title: 'liberte cup-07',
                    file: {
                        url:
                            '//images.contentful.com/kui374n3zzkx/32zLY94KWkgs8QMIEwwI8W/a520080e465a9733e535a1e90aa808e6/liberte_cup-07.png'
                    }
                }
            },
            {
                fields: {
                    title: 'liberte cup-08',
                    file: {
                        url:
                            '//images.contentful.com/kui374n3zzkx/2DiybpR6WEAYgYyEKGo24o/c4ab62ed43a1bb1258c13e63637c8c49/liberte_cup-08.png'
                    }
                }
            }
        ],
        videoID: 208132565,
        client: {
            fields: {
                title: 'ITV 2'
            }
        },
        productionCompany: {
            fields: {
                title: 'Copa90'
            }
        },
        director: {
            fields: {
                title: 'James Willis'
            }
        },
        camera: {
            fields: {
                title: 'Canon c300'
            }
        }
    },
    isLoading: false,
    hasLoaded: false,
    hasError: false
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case ERROR:
            return { ...state, hasError: action.error };
        case LOADING:
            return { ...state, isLoading: action.isLoading };
        case LOADED:
            return { ...state, content: action.payload, hasLoaded: true };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/data/reducers/project.js